import { CaretRight, CheckCircle, type Icon } from '@phosphor-icons/react';

export type LinkingMethodOptionProps = {
	icon: Icon;
	title: string;
	description: string;
	recommended?: boolean;
	onClick: () => void;
};

/**
 * The SAT linking method card (icon + title + description + chevron, with an
 * optional "Recomendado" ribbon). Single source of truth shared by the
 * standalone LinkingFlow method picker and the onboarding regularization
 * picker so both stay visually identical.
 */
const LinkingMethodOption = ({
	icon: OptionIcon,
	title,
	description,
	recommended = false,
	onClick,
}: LinkingMethodOptionProps) => (
	<div className={`p-0.5 rounded-[14px] ${recommended ? 'bg-h-primary' : ''}`}>
		{recommended && (
			<div className='w-full flex justify-center mb-0.5'>
				<div className='flex items-center gap-0.5 font-normal text-xs px-1 rounded-full tracking-tight text-white'>
					Recomendado <CheckCircle weight='fill' />
				</div>
			</div>
		)}

		<div
			className='cursor-pointer flex w-full shadow rounded-xl p-3 md:p-4 items-center gap-3 bg-white'
			onClick={onClick}
		>
			<OptionIcon
				weight='fill'
				className='text-h-primary min-w-[22px] min-h-[22px]'
			/>
			<div className='flex flex-col w-full'>
				<div className='flex items-center gap-1'>
					<p className='font-medium leading-tight'>{title}</p>
				</div>
				<p className='font-light leading-tight'>{description}</p>
			</div>
			<CaretRight
				className='text-h-primary min-w-[20px] min-h-[20px]'
				weight='bold'
			/>
		</div>
	</div>
);

export default LinkingMethodOption;
